import { Check, CheckResult } from '../api'

export const useDokumententresorSessionStorage = (): Check => {
    return {
        id: 'dokumententresor_sessionstorage',
        name: 'SessionStorage',
        link: 'https://developer.mozilla.org/de/docs/Web/API/Window/sessionStorage',
        description: 'Testet, ob der Browser die benötigten APIs zur Verfügung stellt.',
        func: () => {
            return new Promise<CheckResult>((resolve) => {
                const run = async () => {
                    try {
                        sessionStorage.setItem('testKey', 'testValue')
                        const readTestValue = sessionStorage.getItem('testKey')
                        sessionStorage.clear()
                        const readTestValueShouldBeUndefined = sessionStorage.getItem('testKey')
                        const canSessionStorage = readTestValue === 'testValue' && !readTestValueShouldBeUndefined
                        return resolve(
                            canSessionStorage
                                ? { status: 'success' }
                                : { status: 'error', msg: 'Ihr Browser unterstützt die benötigten SessionStorage-APIs nicht.' }
                        )
                    } catch (e) {
                        return resolve({ status: 'error', msg: (e as { message: string }).message })
                    }
                }
                run()
            })
        },
    }
}
